export default function SaveTheDateSection() {
  return (
    <section id="save-the-date" className="save-the-date-section">
      <div className="save-the-date-heading">
        <i className="ri-calendar-heart-line" />
        <div><span /><b>✦</b><span /></div>
        <h2>SAVE THE DATE</h2>
        <p>Reserve esta data para viver conosco uma noite inesquecível.</p>
      </div>

      <div className="save-the-date-frame">
        <video
          controls
          controlsList="nodownload noplaybackrate"
          disablePictureInPicture
          playsInline
          preload="metadata"
          onContextMenu={(event) => event.preventDefault()}
          aria-label="Vídeo Save the Date dos 15 anos da Yasmin"
        >
          <source src="/assets/save-the-date.mp4" type="video/mp4" />
          Seu navegador não oferece suporte à reprodução deste vídeo.
        </video>
      </div>
    </section>
  );
}
